export const Apps = {
  Forms: 'integrated-form-app',
  LiveChat: 'integrated-livechat-app',
  Plugin: 'integrated-plugin-app',
  Background: 'integrated-plugin-proxy',
  GoogleWorkspaceApp: 'integrated-google-workspace-app'
};